import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: 'Cada convulsión te agarra sin saber qué hacer',
  good: 'Protocolo de 7 pasos listo para aplicar en segundos'
}, {
  bad: 'Guardias frecuentes por no saber clasificar la gravedad',
  good: 'Sistema de clasificación que te dice cuándo ir y cuándo no'
}, {
  bad: 'El neurólogo ajusta la medicación a ciegas',
  good: 'Diario de 3 meses de registros que acelera el diagnóstico'
}, {
  bad: 'La maestra entra en pánico si tiene una crisis',
  good: 'Manual escolar en manos del docente desde el primer día'
}, {
  bad: 'Tu familia discute porque no sabe cómo ayudar',
  good: 'Guías individuales para cada integrante de la familia'
}, {
  bad: 'La obra social te rechaza coberturas',
  good: 'Protocolo de reclamo efectivo paso a paso'
}, {
  bad: 'Cada noche dormís con un ojo abierto',
  good: 'Protocolo de seguridad nocturna y señales de alerta temprana'
}, {
  bad: 'La dieta es un misterio',
  good: 'Plan cetogénico de 4 semanas con recetas para niños argentinos'
}];
export const CostComparison = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-white" data-id="element-45">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center mb-8 sm:mb-12 md:mb-16" data-id="element-47">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-48">
            LA REALIDAD
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900" data-id="element-49">
            ¿Cuánto te cuesta NO tenerlo?
          </h3>
        </div>

        <div className="bg-cream-dark rounded-3xl overflow-hidden shadow-sm border border-gray-100" data-id="element-50">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-51">
            {/* Sin el Kit */}
            <div className="p-5 sm:p-6 md:p-8 bg-red-50/50" data-id="element-52">
              <h4 className="text-lg sm:text-xl font-bold text-red-800 mb-6 sm:mb-8 flex items-center gap-2 justify-center md:justify-start" data-id="element-53">
                <XCircle className="text-red-500" size={20} data-id="element-54" /> Sin el Kit
              </h4>
              <ul className="space-y-4 sm:space-y-5 md:space-y-6" data-id="element-55">
                {comparisons.map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900/70" data-id="element-56">
                    <XCircle size={18} className="flex-shrink-0 mt-0.5 text-red-300" data-id="element-57" />
                    <span className="text-sm sm:text-base" data-id="element-58">{item.bad}</span>
                  </li>)}
              </ul>
            </div>

            {/* Con el Kit */}
            <div className="p-5 sm:p-6 md:p-8 bg-brand-green text-white relative" data-id="element-59">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full" data-id="element-60"></div>
              <h4 className="text-lg sm:text-xl font-bold text-brand-gold mb-6 sm:mb-8 flex items-center gap-2 justify-center md:justify-start relative z-10" data-id="element-61">
                <CheckCircle2 className="text-brand-gold" size={20} data-id="element-62" /> Con el
                Kit
              </h4>
              <ul className="space-y-4 sm:space-y-5 md:space-y-6 relative z-10" data-id="element-63">
                {comparisons.map((item, i) => <li key={i} className="flex items-start gap-3 text-cream/90" data-id="element-64">
                    <CheckCircle2 size={18} className="flex-shrink-0 mt-0.5 text-brand-gold" data-id="element-65" />
                    <span className="text-sm sm:text-base font-medium" data-id="element-66">
                      {item.good}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};